export const CLEAR_APP_STORE_DATA = 'CLEAR_APP_STORE_DATA';

/**
 * action to clear app store
 * @param {*} payload 
 */
export function clearAppStoreData (payload) {
  return { type: CLEAR_APP_STORE_DATA, payload: payload };
}
